'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');

var SwitchIOS = React.createClass({
  propTypes: {
    isOpen: React.PropTypes.bool.isRequired
  },
  getInitialState: function () {
    return {
      isOpen: _.isUndefined(this.props.switchStatus) ? this.props.isOpen : (parseInt(this.props.switchStatus, 10) === -1),
      opacity: 1
    }
  },

  componentWillReceiveProps: function (newProps) {
    if (newProps.isOpen !== this.props.isOpen)
      this.setState({isOpen: _.isUndefined(newProps.switchStatus) ? newProps.isOpen : (parseInt(newProps.switchStatus, 10) === -1)})
  },

  render: function () {
    var isOpen = styleHelper.getStateProperty(this.props, propConst.IS_OPEN);
    var size = styleHelper.getSize(this.props);
    var borderColor = styleHelper.getPropertyValue(this.props, propConst.BORDER_COLOR);
    var onColor = styleHelper.getPropertyValue(this.props, propConst.OPEN_COLOR);
    var offColor = styleHelper.getPropertyValue(this.props, propConst.CLOSE_COLOR);

    if (!onColor) {
      onColor = '#5f5';
    }
    if (!offColor) {
      offColor = '#fff';
    }

    var stateStyle = {
      width: this.props.h - 2,
      height: size.height - 2,
      top: 1
    };

    if (_.isUndefined(isOpen)) {
      isOpen = this.state.isOpen;
    }

    if (isOpen) {
      stateStyle.right = 1;
      stateStyle.borderColor = onColor;
    } else {
      stateStyle.left = 1;
      stateStyle.borderColor = offColor;
    }
    return (
      <div>
        <div className="component contents-layout border"
             style={{
               borderTopLeftRadius: size.height / 2 + 'px 50%',
               borderTopRightRadius: size.height / 2 + 'px 50%',
               borderBottomLeftRadius: size.height / 2 + 'px 50%',
               borderBottomRightRadius: size.height / 2 + 'px 50%',
               backgroundColor: isOpen ? onColor : offColor,
               borderColor: styleHelper.getBorderColor(this.props) || '#000',
               border: this.props.borderVisible ? '1px solid ' + this.props.borderVisible : 'none'
             }}
             onClick={this.onClick}>
        </div>
        <div ref="btn" className="button" style={stateStyle}></div>
      </div>
    );
  },

  onClick: function (e) {
    var ani;
    var isOpen = !this.state.isOpen;
    var w = styleHelper.getWidth(this.props);
    var h = this.props.h - 2;
    var s = h;
    var margin = 1;
    if (isOpen) {
      ani = {
        left: w - s - margin
      }
    } else {
      ani = {
        left: margin
      }
    }
    $(ReactDOM.findDOMNode(this.refs.btn)).animate(ani, 150);

    if (isOpen) {
      this.props.events.switchOn(e, this.props, 'interactive-link', 0);
    } else {
      this.props.events.switchOff(e, this.props, 'interactive-link', 0);
    }

    this.setState({
      isOpen: isOpen
    });
  },

  componentDidMount: function () {
    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onClick);
  }
});
module.exports = SwitchIOS;



// WEBPACK FOOTER //
// ./src/views/Components/SwitchIOS.jsx